module.exports = __webpack_public_path__ + "img/voiding-chart-slide1.e45afe30.gif";